import Portal = require("portal-gis");
import Base = require("./base-collection");

class Collection extends Base<Portal.MapBookmarkLeaf> {
    static about = `Bookmarks`;
}

export = Collection; 